import { el } from "date-fns/locale";
import { createContext, useEffect, useState, useTransition } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Loader from "../components/Loader";

export const UserAuth = createContext(null);

export default function UserAuthProvider({ children }) {
  const [userData, setUserData] = useState(null);

  const { t } = useTranslation("general");
  const navigate = useNavigate();

  // console.log("userData Context", userData);

  useEffect(() => {
    const userType = localStorage.getItem("userType");

    const username = localStorage.getItem("username");
    // const customerId = localStorage.getItem("customerId");

    const token = localStorage.getItem("token");

    if (!token) navigate("/login");

    if (userType === "organization") {
      const organizationId = localStorage.getItem("organizationId");
      const organizationType = localStorage.getItem("organizationType");
      const organizationName = localStorage.getItem("organizationName");
      const specialOrg = localStorage.getItem("specialOrg");
      const subCompany = JSON.parse(localStorage.getItem("subCompany"));

      setUserData({
        userType,
        username,
        organizationId,
        organizationType,
        organizationName,
        token,
        subCompany,
        specialOrg: specialOrg === "true",
      });
    } else if (userType === "orgUser") {
      const userId = localStorage.getItem("userId");
      const organizationId = localStorage.getItem("organizationId");
      const organizationType = localStorage.getItem("organizationType");
      const organizationName = localStorage.getItem("organizationName");
      const phoneNumber = localStorage.getItem("phoneNumber");
      const role = localStorage.getItem("role");
      const specialty = localStorage.getItem("specialty");
      const subCompany = JSON.parse(localStorage.getItem("subCompany"));
      const email = localStorage.getItem("email");


      setUserData({
        userType,
        username,
        userId,
        organizationId,
        organizationType,
        organizationName,
        phoneNumber,
        token,
        role,
        email,
        specialty,
        subCompany,
      });
    } else if (userType === "user") {
      const email = localStorage.getItem("email");
      const phoneNumber = localStorage.getItem("phoneNumber");
      const userId = localStorage.getItem("userId");
      const username = localStorage.getItem("username");

      setUserData({
        userType,
        username,
        userId,
        email,
        phoneNumber,
        token,
      });
    } else if (userType === "superadmin") {
      const email = localStorage.getItem("email");
      const phoneNumber = localStorage.getItem("phoneNumber");
      const userId = localStorage.getItem("userId");
      const username = localStorage.getItem("username");

      setUserData({
        userType,
        username,
        userId,
        email,
        phoneNumber,
        token,
      });
    } else if (userType === "admin") {
      const email = localStorage.getItem("email");
      const phoneNumber = localStorage.getItem("phoneNumber");
      const userId = localStorage.getItem("userId");
      const username = localStorage.getItem("username");

      setUserData({
        userType,
        username,
        userId,
        email,
        phoneNumber,
        token,
      });
    }
  }, []);

  // console.log("userData", userData);

  if (!userData) {
    return <Loader fullHeight={true} />;
  }

  return (
    <UserAuth.Provider value={{ userData, setUserData }}>
      {children}
    </UserAuth.Provider>
  );
}
